(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productV2JSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productV2VariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.productV2 = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const productSwiper = new Swiper(section.querySelector(".productV2VisualSwiper"), {
        slidesPerView: 1,
        spaceBetween: 20,
        autoHeight: true,
        on: {
            slideChange: function () {
                if (!section.querySelector(".productV2VisualSwiperSlide")) {
                    return;
                }
                // update the thumbnail active class
                section.querySelector(".productV2VisualThumbsSlide.active").classList.remove("active");
                section.querySelectorAll(".productV2VisualThumbsSlide")[this.realIndex].classList.add("active");

                // pause all videos
                section.querySelectorAll(".productV2VisualSwiperSlide video").forEach(element => {
                    element.pause();
                });
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productV2VisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productV2VisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productV2VisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // change slide on thumbnail click
    section.querySelectorAll(".productV2VisualThumbsSlide").forEach(element => {
        element.addEventListener("click", function () {
            // change slide
            productSwiper.slideTo(this.dataset.index - 1);
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!document.querySelector(`.productV2FormSellingOptionHeaderInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productV2FormSellingOptionPlan').value);
    }

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            let variant = section.querySelector(".productV2FormOptionsLabelInput:checked").value;
            if (variant !== "") {
                activeVariant = JSON.parse(variant);
            }

        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll('.productV2ATC').forEach(element => {
                element.disabled = true;
                element.querySelector(".productV2ATCText").textContent = "Not Available";

            });
            return;
        }

        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productV2FormSellingOptionPriceCompare");
            const reals = section.querySelectorAll(".productV2FormSellingOptionPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price * quantity);
            }
            subReal.textContent = price(allocationPrice * quantity);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price * quantity);
            }
            oneTimeReal.textContent = price(activeVariant.price * quantity);

            // check if subscription checked and update sticky price
            section.querySelector('.productV2StickyPrice').textContent = price(activeVariant.price * quantity);
            if (isSubscription()) {
                section.querySelector('.productV2StickyPrice').textContent = price(allocationPrice * quantity);
            }

            // update per can price (price/cans)
            let cansExist = document.querySelector('.productV2FormSellingOptionRightPer') || false;
            if (cansExist) {
                let cans = parseInt(section.querySelector('.productV2FormOptionsLabelInput:checked').dataset.cans)

                section.querySelector('.productV2FormSellingOptionRightPer.sub').textContent = price((allocationPrice * quantity) / cans) + ' Per Can'
                section.querySelector('.productV2FormSellingOptionRightPer.once').textContent = price((activeVariant.price * quantity) / cans) + ' Per Can'
            }


        } else {
            // Non-subscription scenario
            const compareEl = section.querySelector(".productV2PriceCompare");
            const realEl = section.querySelector(".productV2PriceReal");

            realEl.classList.remove('sale');
            section.querySelector('.productV2BadgeSale').classList.remove('active');

            compareEl.textContent = '';

            if (activeVariant.compare_at_price > activeVariant.price) {
                compareEl.textContent = price(activeVariant.compare_at_price * quantity);
                realEl.classList.add('sale');

                // if the product isn't sold out, show sale badge
                if (activeVariant.available) {
                    section.querySelector('.productV2BadgeSale').classList.add('active');
                }

            }
            realEl.textContent = price(activeVariant.price * quantity);
            section.querySelector('.productV2StickyPrice').textContent = price(activeVariant.price * quantity);
        }


        /**************
         Available / Sold Out
         ***************/
        // when sold out, hide the product form and show the sold out form
        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelectorAll('.productV2ATC').forEach(element => {
                element.classList.remove('OOS');
                element.disabled = false;
                element.querySelector('.productV2ATCText').textContent = "Add To Cart";
            })
            section.querySelector('.productV2BadgeOOS').classList.remove('active');
            section.querySelector('.productV2OOSTitle').classList.remove('active');
            section.querySelector('.productV2Price')?.classList.add('active');
            section.querySelectorAll('.productV2Cans')?.forEach(element => {
                element.classList.add('active');
            });
            section.querySelector('.productV2OOSInput').classList.remove('active');
            section.querySelector('.productV2Wrap').classList.remove('smallMargin');

            // selling plan / variant options
            if (product.selling_plan_groups.length > 0) {
                section.querySelector('.productV2FormSelling').classList.add('active');
            }
            if (product.variants.length > 1) {
                section.querySelector('.productV2FormOptions').classList.add('active');
            }
            section.querySelector('.productV2Sticky').classList.add('active');

        } else {
            section.querySelectorAll('.productV2ATC').forEach(element => {
                element.classList.add('OOS');
                element.querySelector('.productV2ATCText').textContent = "Submit";
            })
            section.querySelector(".productV2ATC").classList.add('OOS');
            section.querySelector(".productV2ATCText").textContent = "Submit";
            section.querySelector('.productV2BadgeOOS').classList.add('active');
            section.querySelector('.productV2OOSTitle').classList.add('active');
            section.querySelector('.productV2Price')?.classList.remove('active');
            section.querySelectorAll('.productV2Cans')?.forEach(element => {
                element.classList.remove('active');
            });
            section.querySelector('.productV2OOSInput').classList.add('active');
            section.querySelector('.productV2BadgeSale').classList.remove('active');
            section.querySelector('.productV2Wrap').classList.add('smallMargin');

            // selling plan / variant options
            if (product.selling_plan_groups.length > 0) {
                section.querySelector('.productV2FormSelling').classList.remove('active');
            }
            if (product.variants.length > 1) {
                section.querySelector('.productV2FormOptions').classList.remove('active');
            }

            section.querySelector('.productV2Sticky').classList.remove('active');

        }

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/
    // minus
    section.querySelectorAll(".productV2QuantityControlsBtn.minus")?.forEach(element => {
        element.addEventListener("click", function () {
            if (quantity === 1) {
                return;
            }
            quantity--;
            section.querySelectorAll(".productV2QuantityControlsValue").forEach(element => {
                element.textContent = quantity;
            });
            updateProduct();
        });
    });

    // plus
    section.querySelectorAll(".productV2QuantityControlsBtn.plus")?.forEach(element => {
        element.addEventListener("click", function () {
            quantity++;
            section.querySelectorAll(".productV2QuantityControlsValue").forEach(element => {
                element.textContent = quantity;
            });
            updateProduct();
        });
    });


    /**************
     Product ATC
     ***************/

    section.querySelectorAll('.productV2ATC').forEach(element => {
        element.addEventListener('click', async function () {

            // add loading animation to both buttons
            section.querySelectorAll(".productV2ATC").forEach(element => {
                element.classList.add("loading");
            });

            // check for OOS
            if (element.classList.contains("OOS")) {

                // if input is empty, return
                if (section.querySelector('.productV2OOSInput').value === '') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Please enter a valid email address',
                    });
                    section.querySelectorAll(".productV2ATC").forEach(element => {
                        element.classList.remove("loading");
                    });
                    return;
                }

                // add to OOS list and return
                await sendKlaviyoBackInStockRequest(section.querySelector('.productV2OOSInput').value, activeVariant.id);
                Swal.fire({
                    icon: 'success',
                    title: `Thanks! We'll let you know when this product is back in stock.`,
                });
                section.querySelectorAll(".productV2ATC").forEach(element => {
                    element.classList.remove("loading");
                });
                return;
            }


            let formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                }]
            };

            // check for selling plan
            if (isSubscription()) {
                formData.items[0].selling_plan = parseInt(section.querySelector('.productV2FormSellingOptionPlan').value)
            }

            // add product
            await addProduct(formData);

            // remove loading animation
            section.querySelectorAll(".productV2ATC").forEach(element => {
                element.classList.remove("loading");
            });

            // open cart
            await openCart();
        });
    });


    /** Block - Dropdown **/

    // setup dropdowns
    section.querySelectorAll(".productV2DropdownToggle").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });


    /**************
     Locations
     ***************/
    // hit geoip.maltertech.com to get the user's location
    // if province is california, show the locations link
    (async () => {
        await fetch("https://geoip.maltertech.com")
            .then(response => response.json())
            .then(data => {
                if (data.region === "California") {
                    section.querySelectorAll('.productV2Location').forEach(element => {
                        element.classList.add('active');
                    });
                }
            });
    })();

    /**************
     Reviews link
     ***************/
    section.querySelectorAll('.productV2Reviews')?.forEach(element => {
        element.addEventListener('click', function () {
            // smooth scroll to reviews
            document.querySelector('#reviews').scrollIntoView({
                behavior: 'smooth'
            });


        });
    });

    /**************
     Nutrition Dialog
     ***************/
    let nutritionExists = section.querySelector('.nutrition') || false;

    if (nutritionExists) {
        // swiper
        let nutritionSwiper = new Swiper(section.querySelector(".nutritionSwiper"), {
            slidesPerView: 1,
            spaceBetween: 20
        });

        // thumbnails
        document.querySelectorAll('.nutritionSwiperThumbsBtn')?.forEach(element => {
            element.addEventListener('click', function () {

                document.querySelectorAll('.nutritionSwiperThumbsBtn').forEach(element => {
                    element.classList.remove('active');
                });

                element.classList.add('active');

                let target = this.dataset.target;
                nutritionSwiper.slideTo(target);

            });
        });

        // open nutrition dialog
        section.querySelectorAll('.openNutrition').forEach(function (element) {
            element.addEventListener('click', function () {
                section.querySelector(".nutrition").showModal();
                document.querySelector("body").classList.add("noScroll");
            });
        })

        // close nutrition
        function closePopup() {
            section.querySelector(".nutrition").close();
            document.querySelector("body").classList.remove("noScroll");
        }

        // close nutrition event listener
        section.querySelectorAll(".nutritionClose").forEach(function (element) {
            element.addEventListener("click", closePopup);
        });

        section.querySelector(".nutrition")?.addEventListener("click", function (e) {
            if (e.target === this) {
                closePopup();
            }
        })

        // close event
        section.querySelector(".nutrition")?.addEventListener("close", function () {
            document.querySelector("body").classList.remove("noScroll");
        });

        // register dialog
        dialogPolyfill.registerDialog(section.querySelector(".nutrition"));
    }
})();